import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export type DelinquencyState = "CURRENT" | "WARNED" | "BLOCKED" | "TRANSFERRED";

export interface EcDelinquency {
  id                  : string;
  tenantId            : string;
  endCustomerBusinessId: string;
  state               : DelinquencyState;
  overdueAmount       : string;
  lastReminderAt      : string | null;
  enteredStateAt      : string;
  createdAt           : string;
  updatedAt           : string;
}

export interface DelinqListParams {
  tenantId?: string;
  state?: DelinquencyState;
  page?: number;
  limit?: number;
}

export const listMy = (params?: DelinqListParams) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.get("/bil/my/ec-delinquencies", params as any);

export const listAdmin = (params?: DelinqListParams) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.get("/bil/admin/ec-delinquencies", params as any);

export const runDelinquency = (body: { date?: string } = {}) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.post("/bil/admin/ec/run-delinquency", body as any);
